module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"MainMenuDropdownContent":{"heading":"Kategorie"}},"en":{"MainMenuDropdownContent":{"heading":"Category"}}}')
  delete Component.options._Ctor
}
